import { BreadcrumbMenu } from "~Common/BreadcrumbMenu/BreadcrumbMenu.tsx";
import { Suspense } from "react";
import { Skeleton } from "antd";
import { Outlet } from "react-router";
import { Footer } from "../Footer/Footer.tsx";
import { useAppSettings } from "~context/AppSettingsContext/AppSettingsContext.tsx";

export const Content = () => {
  const {displayWidthConstrained} = useAppSettings()
  return (
    <div className={displayWidthConstrained ? "constrained-wrapper" : "not-constrained-wrapper"}>
      <div className={`main-content ${displayWidthConstrained ? "constrained-content" : ""}`}>
        <div className="breadcrumb-menu-wrapper">
          <BreadcrumbMenu/>
        </div>
        <Suspense fallback={<Skeleton/>}>
          <Outlet/>
        </Suspense>
      </div>
      <div className="footer-wrapper">
        <Footer/>
      </div>
    </div>
  )
}